import { useState } from "react";
import { getCostCenterValidationReportDetail } from "../api/reportsClient";
import { FlagProjectsReportDetail } from "../api/models/ReportModels";

export const useReportDetail = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [reportDetail, setReportDetail] = useState<FlagProjectsReportDetail | null>(null);

    const fetchReportDetail = async (id: number) => {
        setIsLoading(true);
        try {
            const data = await getCostCenterValidationReportDetail(id);
            setReportDetail(data);
        } catch (error) {
            console.error("Error fetching report detail:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        reportDetail,
        fetchReportDetail
    };
};
